/* eslint-disable import/prefer-default-export */
export const TCPAAreaCodes = [
  {
    areaCodes: [
      '239',
      '305',
      '321',
      '352',
      '386',
      '407',
      '561',
      '727',
      '772',
      '813',
      '850',
      '863',
      '904',
      '941',
      '954',
    ],
    state: 'FL',
  },
  { areaCodes: ['405', '580', '918'], state: 'OK' },
  { areaCodes: ['206', '253', '360', '425', '509'], state: 'WA' },
];

export const TCPA_OUTCOMES = {
  OPT_IN: 'Opt-In',
  OPT_OUT: 'Opt-Out',
  CLEARED_PHONE: 'Cleared Phone',
  CHANGED_PHONE: 'Changed Phone',
};
